module.exports = __webpack_public_path__ + "static/img/06.254cde7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/FamilyAlbum/06.jpg
// module id = Iokf
// module chunks = 7